import ModalPopup from './ModalPopup';
import * as React from 'react';

interface ModalErrorPopupProps {
  title: string | undefined;
  message: string | undefined;
  onClose: () => void;
}

// A message may carry line breaks: the picture delete summary lists its reasons, the file upload its failed files.
// HTML collapses a newline in plain text, so each line is its own block (#116).
// An empty line (`\n\n`) becomes an empty block with no height, so it shows no gap. No caller writes one.
const ModalErrorPopup = ({ title, message, onClose }: ModalErrorPopupProps) => {
  return (
    <ModalPopup title={title} open={!!message} onClose={onClose} actionButtons={null} describedByContent>
      {message?.split('\n').map((line, index) => (
        // Lines have no identity of their own: the message is replaced whole, never edited in place.
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>{line}</div>
      ))}
    </ModalPopup>
  );
};

export default ModalErrorPopup;
